import React from 'react';
import { HStack, Text, type StackProps } from '@chakra-ui/react';

interface ExpirySummaryBarProps {
	label: string;
	value: string;
}

const ExpirySummaryBar: React.FC<ExpirySummaryBarProps & StackProps> = ({ label, value, ...rest }) => (
	<HStack justify="space-between" align="center" py={2} {...rest}>
		<Text textStyle="label" color="fg.muted">
			{label}
		</Text>
		<Text textStyle="body.strong">{value}</Text>
	</HStack>
);

export default ExpirySummaryBar;
